// Helpers to build the talent contract signing payload from the profileuser data.

const cleanValue = (value) => {
  if (value == null) return ''
  return String(value).trim()
}

// Builds the full address string: country + state + city.
export const buildTalentAddress = (user = {}) => {
  const address = user?.address ?? {}
  const parts = [
    address?.country?.country_name,
    address?.state?.state_name,
    address?.city?.city_name,
  ]
    .map(cleanValue)
    .filter(Boolean)

  return parts.join(', ')
}

// Extracts fullName, address and dni from the profileuser payload.
export const getTalentContractData = (profileUser = {}) => {
  const user = profileUser?.userInfo?.user ?? {}

  const fullName = [cleanValue(user?.names), cleanValue(user?.surnames)]
    .filter(Boolean)
    .join(' ')
    .trim()

  const address = buildTalentAddress(user)
  const dni = cleanValue(user?.dni)

  return { fullName, address, dni }
}

// Returns the list of missing required fields (empty array means complete).
export const getMissingTalentContractFields = (data = {}) => {
  const missing = []
  if (!data.fullName) missing.push('Nombre completo')
  if (!data.address) missing.push('Dirección')
  if (!data.dni) missing.push('Documento de identidad (DNI)')
  return missing
}

export const hasTalentContractData = (data = {}) =>
  getMissingTalentContractFields(data).length === 0

// Talent's stored signature lives under references.talentContactSignature.
// A "{FIRMA}" placeholder (or empty) means the contract is not signed yet.
export const normalizeTalentSignature = (value) => {
  if (value == null) return ''
  if (typeof value === 'number') return String(value).trim()
  if (typeof value !== 'string') return ''

  const normalized = value.trim()
  const compact = normalized.replace(/[\s"'`]/g, '').toUpperCase()
  if (compact === '{FIRMA}' || compact === 'FIRMA') return ''
  return normalized
}
